import { useTranslation } from 'react-i18next';
import { APPLICATION_FLOW_STATUS } from 'typescript/types/api/capital_shop/application_flows';
import { QUERY_KEYS } from 'typescript/constants/react_query';
import { useInvalidateQuery } from 'typescript/hooks/use_react_query_utils';
import Dialog from 'typescript/components/dialog';
import { usePaymentContext } from 'typescript/context/payment_context';
import { onCheckoutPageClick } from 'typescript/utilities/tracking';
import { CHECKOUT_PAGE_CLICK_EVENTS } from 'typescript/constants/tracking';
import { useCheckoutFlow } from 'typescript/context/checkout_flow';

export const INSTALLMENTS_DENIED_TEST_ID = 'installments-denied-test-id';
export const INSTALLMENTS_GENERIC_ERROR_TEST_ID =
  'installments-generic-error-test-id';

const InstallmentsDialog = () => {
  const { t } = useTranslation();
  const { trackingData } = useCheckoutFlow();
  const { invalidate: invalidateQuery } = useInvalidateQuery();
  const { setShowInstallmentDecision, applicationFlowStatus } =
    usePaymentContext();

  if (applicationFlowStatus === APPLICATION_FLOW_STATUS.DECLINED) {
    return (
      <Dialog
        dataTestId={INSTALLMENTS_DENIED_TEST_ID}
        header={t('checkout.dialog.errors.title')}
        body={t('checkout.dialog.errors.body.installment')}
        showButton
        buttonText={t('checkout.dialog.cta')}
        buttonOnClick={() => {
          onCheckoutPageClick({
            eventDesc:
              CHECKOUT_PAGE_CLICK_EVENTS.installments_denied_return_to_checkout,
            trackingData,
          });
          setShowInstallmentDecision(false);
          invalidateQuery(QUERY_KEYS.PAYMENT_OPTIONS);
        }}
      />
    );
  }

  return (
    <Dialog
      dataTestId={INSTALLMENTS_GENERIC_ERROR_TEST_ID}
      header={t('checkout.dialog.errors.title')}
      body="We're unable to verify your identity. Please try again."
      showButton
      buttonText={t('checkout.dialog.cta')}
      buttonOnClick={() => {
        onCheckoutPageClick({
          eventDesc:
            CHECKOUT_PAGE_CLICK_EVENTS.installments_pending_return_to_checkout,
          trackingData,
        });
        setShowInstallmentDecision(false);
      }}
    />
  );
};

export default InstallmentsDialog;
